import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Fixed admin credentials
  const ADMIN_CREDENTIALS = {
    email: 'admin@symbolfly.com',
    password: 'admin123'
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      // Validate credentials
      if (
        loginData.email.toLowerCase().trim() === ADMIN_CREDENTIALS.email.toLowerCase() &&
        loginData.password === ADMIN_CREDENTIALS.password
      ) {
        // Store admin session
        localStorage.setItem('isAdmin', 'true');
        localStorage.setItem('adminEmail', loginData.email);
        
        // Dispatch event to update any admin-related UI
        window.dispatchEvent(new Event('adminStatusChange'));
        
        // Navigate to admin dashboard
        navigate('/admin/dashboard');
      } else {
        setError('Invalid email or password. Please try again.');
        setIsLoading(false);
      }
    }, 500);
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-icon">🔐</div>
            <h1 className="admin-login-title">Admin Login</h1>
            <p className="admin-login-subtitle">
              Access the admin dashboard with your credentials
            </p>
          </div>

          <form onSubmit={handleLogin} className="admin-login-form">
            {error && (
              <div className="admin-error-message">
                {error}
              </div>
            )}

            <div className="admin-form-group">
              <label htmlFor="email" className="admin-form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={loginData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                className="admin-form-input"
                required
                autoComplete="email"
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="password" className="admin-form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={loginData.password}
                onChange={handleInputChange}
                placeholder="Enter your password"
                className="admin-form-input"
                required
                autoComplete="current-password"
              />
            </div>

            <button 
              type="submit" 
              className="admin-login-button"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Login to Admin Panel'}
            </button>
          </form>

          <div className="admin-login-footer">
            <p className="admin-footer-text">
              Authorized personnel only
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

